// extracted by mini-css-extract-plugin
module.exports = {"icon":"Panel_style_icon__3iRA7","title":"Panel_style_title__lXDTp"};